import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";
import { LoadingState } from "@/components/feedback/LoadingState";

export function CallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useTranslation("auth");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get("token");
    const dev = params.get("dev_bypass");
    if (!token && !dev) {
      setError(t("noToken"));
      return;
    }
    void (async () => {
      try {
        await login(token ?? "dev-bypass-token");
        navigate("/", { replace: true });
      } catch (err) {
        console.error("Callback error", err);
        setError(t("callbackError"));
      }
    })();
  }, [params, login, navigate, t]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4 text-center">
        <div className="max-w-sm">
          <p className="text-danger-700">{error}</p>
        </div>
      </div>
    );
  }

  return <LoadingState message={t("callbackProcessing")} />;
}
